import { AdminReturnWorkflowStatus } from "@redotech/redo-temporal-common/workflow-status";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const upsertWorkflowStatus = {
  name: "upsertWorkflowStatus" as const,
  input: z.object({
    teamId: zExt.objectId(),
    returnId: zExt.objectId(),
    workflowId: z.string(),
    workflowType: z.string(),
    status: createEnum(AdminReturnWorkflowStatus),
    message: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
